import { SponsoredSolarRouterController } from './router-controller';

/**
 * Sponsored Solar Router Controller manages the routing of the sponsored solar
 * funnel when the browser is reloaded. Individual components/steps will still
 * have freedom to route anywhere they want depending upon the business logic.
 * This controller is only to prevent users from skipping steps in the funnel
 * by directly navigating to a later step.
 *
 * for future funnels, create similar Routers.
 */
export const SponsoredSolarRouter = SponsoredSolarRouterController();
